const Certificates = () => {
  return <div className="flex min-h-[calc(100vh-73px)] flex-col items-center justify-center"></div>;
};

export default Certificates;
